const MultipleSeatsSelect = {
  order: Infinity,
  run($$) {
    $$.$arena.selectable({
      filter: ".seats-container > [data-type]",
      start() {
        $(".ui-selected").removeClass(".ui-selected");
      },
      stop() {
        const coordsPairs = R.pipe(
          R.filter((_, el) => $$.selectionFilter($(el).data())),
          R.map(function (_, el) {
            const seatData = $(el).data();
            const seat = $$.getSeat(seatData.row, seatData.coll);
            seat.selected = (seat.selected === undefined ? false : seat.selected);
            return seat;
          }),
          R.groupBy(R.prop("selected"))
        )($(".ui-selected", this));

        if (coordsPairs.true) {
          $$.deselectSeats(coordsPairs.true);
        }
        if (coordsPairs.false) {
          $$.selectSeats(coordsPairs.false);
        }
      },
    });
  },
  destroy($$) {
    $$.$arena.selectable("destroy");
  },
};

window.SectionMultipleSeatsSelect = MultipleSeatsSelect;

export default MultipleSeatsSelect;
